import axios from "axios";
import { store } from "../../../redux/store";
import Provider from "~shared/singleton";
import { getCookie } from "../../utils/cookie";
const providerInstance = Provider.getInstance();
/*global POS_API, API_VERSION*/
/*eslint no-undef: "error"*/
const POS = axios.create({
  baseURL: POS_API + API_VERSION,
  timeout: 16000,
});

const getAuthToken = () => {

  return store.getState().authentication?.retailer_auth?.response?.responseData?.accessToken;
};

const handleRequest = async (req) => {
  const schema = providerInstance.getSchema() || getCookie("schema_name");
  if (schema) {
    req.headers["X-TenantSchema"] = schema;
  }

  const isRefreshEndpoint = req.url && req.url.includes("auth/refresh");
  const accessToken = getAuthToken();
  if (accessToken && !isRefreshEndpoint) {
    req.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return req;
};

const handleError = (error) => {
  /*eslint no-undef: "error"*/
  let parsed_error = Object.assign({}, error);
  return Promise.reject(parsed_error?.response?.data);
};

const handleResponse = (response) => {
  return Promise.resolve(response.data);
};

POS.interceptors.request.use(handleRequest);
POS.interceptors.response.use(handleResponse, handleError);

export default POS;